import { render, staticRenderFns } from "./card-expiration.vue?vue&type=template&id=1a658bd2"
import script from "./card-expiration.ts?vue&type=script&lang=ts&external"
export * from "./card-expiration.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports